/** @format */

import { toast, ToastContainer } from "react-toastify";
import { useEffect } from "react";

export const ToastNotification = () => {
	useEffect(() => {
		const handleKeyDown = (e: KeyboardEvent) => {
			if (e.key === "Escape") {
				toast.dismiss();
			}
		};
		globalThis.window.addEventListener("keydown", handleKeyDown);
		return () => globalThis.window.removeEventListener("keydown", handleKeyDown);
	}, []);

	return (
		<ToastContainer position="top-center" autoClose={5000} stacked={true} style={{ width: "400px", height: "auto" }} />
	);
};
